const faqAccordion = ($el) => {
    if (typeof $el !== "undefined" && $el != null) {
        const accordionItems = [...$el.querySelectorAll(".js-accordion-item")]
        const isActiveClass = "is-active"

        if (typeof accordionItems !== "undefined" && accordionItems) {

            /**
             * Open accordion function
             * @param {*} accordionBtn
             * @param {*} target
             */
            const openAccordionItem = (accordionBtn, target) => {
                accordionBtn.setAttribute("aria-expanded", true)
                accordionBtn.parentNode.classList.add(isActiveClass)
                target.style.maxHeight = target.scrollHeight + "px"
                target.style.marginBottom = "2.8rem"
            }

            /**
             * Close accordion function
             * @param {*} accordionBtn
             * @param {*} target
             */
            const closeAccordionItem = (accordionBtn, target) => {
                accordionBtn.setAttribute("aria-expanded", false)
                accordionBtn.parentNode.classList.remove(isActiveClass)
                target.style.maxHeight = 0
                target.style.marginBottom = "0"
            }

            /**
             * Handle first accordion item
             */
            accordionItems.map((accordionItem, index) => {
                if (index > 0) {
                    const accordionBtn = accordionItem.querySelector(".js-accordion-btn")
                    let target = accordionBtn.nextElementSibling
                    accordionBtn.parentNode.classList.remove(isActiveClass)
                    // accordionBtn.setAttribute("aria-expanded", false)
                    closeAccordionItem(accordionBtn, target)
                } else {
                    const accordionBtn = accordionItem.querySelector(".js-accordion-btn")
                    let target = accordionBtn.nextElementSibling
                    openAccordionItem(accordionBtn, target)
                }

            })

            /**
             * Loop through all the accordion items and bind the click event to the button
             */
            accordionItems.forEach(accordionItem => {
                const accordionBtn = accordionItem.querySelector(".js-accordion-btn")

                let target = accordionBtn.nextElementSibling

                accordionBtn.addEventListener("click", () => {
                    let isExpanded = accordionBtn.getAttribute("aria-expanded") === "true"
                    if (isExpanded) {
                        closeAccordionItem(accordionBtn, target)
                    } else {
                        openAccordionItem(accordionBtn, target)
                    }
                })
            })
        }
    }
}

export default faqAccordion
